import { css } from '@/styled-system/css';

export const toggleCardContentStyles = css.raw({
  'pointerEvents': 'none',
  'position': 'relative',
  'zIndex': 1,

  '& :where(a, button, input, select, textarea, summary, [contenteditable="true"], [role="button"], [role="checkbox"], [role="combobox"], [role="link"], [role="radio"], [role="switch"], [tabindex]:not([tabindex="-1"]))':
    {
      pointerEvents: 'all',
    },
});
